import { render, staticRenderFns } from "./TariffGreenCardItem.vue?vue&type=template&id=3b2ced3a&scoped=true&"
import script from "./TariffGreenCardItem.vue?vue&type=script&lang=ts&"
export * from "./TariffGreenCardItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffGreenCardItem.vue?vue&type=style&index=0&id=3b2ced3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ced3a",
  null
  
)

export default component.exports